module.exports = __webpack_public_path__ + "static/media/8-blushes-value-grayscale.8e01bbe7.jpg";